export enum EnumLoginErrorLabel {
  NotRegistered = 'NotRegistered',
  EmailInvalid = 'EmailInvalid',
}
